import { BreadcrumbBox } from '@/features/Breadcrumb';
import { Image, RichText } from '@/features/shared';
import { MuiTypography } from '@/features/shared/material-ui';
import clsx from 'clsx';
import React, { memo } from 'react';
import { DetailPageHeaderProps } from './DetailPageHeader.interface';
import useStyles from './DetailPageHeader.styles';

const DetailPageHeader = ({
  headline,
  logo,
  shortDescription,
  theme,
  includeBreadcrumb,
}: DetailPageHeaderProps) => {
  const classes = useStyles({});

  const rootClasses = clsx(classes.root, `${theme}-theme`);

  return (
    <header className={rootClasses}>
      {includeBreadcrumb && <BreadcrumbBox className={classes.breadcrumb} theme={theme} />}
      {logo && (
        <div className={classes.logo}>
          <Image image={logo} />
        </div>
      )}

      {!logo && headline && (
        <MuiTypography variant="h5" component="h5" className={classes.heading}>
          {headline}
        </MuiTypography>
      )}

      <RichText className={classes.shortDescription} content={shortDescription} theme={theme} />
    </header>
  );
};

export default memo(DetailPageHeader);
